import useSWR from 'swr';
import ReportDataType from '@/constants/api/ReportDataType';
import useOwnerOrgId from '@/lib/hooks/useOwnerOrgId';
import fetcher from '@/lib/swr/fetcher';
import type OpportunitiesByConfidenceLevel from '@/types/api/OpportunitiesByConfidenceLevel';
import type OpportunitiesByStageReport from '@/types/api/OpportunitiesByStage';
import joinNonEmptyParams from '@/utils/joinNonEmptyParams';
import GroupingType from '../constants/GroupingType';
import type OpportunitiesFilterParams from '../types/OpportunitiesFilterParams';
import mapQueryToFilter from '../utils/mapQueryToFilter';

export default function useGroupedOpportunitiesTotals({
  id,
  type,
  filters,
}: {
  id: string;
  type: GroupingType;
  filters: OpportunitiesFilterParams;
}) {
  const ownerOrgId = useOwnerOrgId();
  const reportName =
    type === GroupingType.STAGE
      ? ReportDataType.OPPORTUNITIES_BY_STAGE
      : ReportDataType.OPPORTUNITIES_BY_CONFIDENCE_LEVEL;
  const { data, isLoading } = useSWR<
    | {
        report: OpportunitiesByStageReport[] | OpportunitiesByConfidenceLevel[];
      }
    | undefined
  >(
    `reporting/${ownerOrgId}/dashboards/opportunities/${reportName}?${joinNonEmptyParams(
      {
        ...mapQueryToFilter(filters),
        ...(type === GroupingType.STAGE && { opportunityStageIds: id }),
        ...(type === GroupingType.CONFIDENCE_LEVEL && {
          confidenceLevelIds: id,
        }),
      },
      true,
    )}`,
    fetcher,
  );

  return {
    data: data?.report?.[0],
    isLoading,
  };
}
